var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-container"},[_c('img',{attrs:{"src":_vm.image,"alt":"Image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }